module.exports = __webpack_public_path__ + "static/media/pop_danger_bg@2x.ad03750c.png";